import { Observable } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError } from 'rxjs/operators';
import { GlobalEnvironment, getParams, postParams, putParams } from 'Helpers';
import { Serial } from 'Models';
import { msalTemp } from 'Contexts/AuthProvider';

export class SerialService {

    static GetSerials(): Observable<Serial[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/Serial`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(response.statusText);
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
    static GetSerialByProjectId(serial: Serial): Observable<Serial[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/Serials/ProjectId/${serial}`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(response.statusText);
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
    static SaveSerial(serial: Serial): Observable<Serial> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...putParams(JSON.stringify(serial)), headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/Serial/save`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(response.statusText);
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
    static SaveSerials(serials: Serial[]): Observable<Serial[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ... putParams(JSON.stringify(serials)), headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/Serial/UpdateSerials`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(response.statusText);
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
    static InsertSerials(serials: Serial[]): Observable<Serial[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...postParams(JSON.stringify(serials)), headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/Serial/InsertSerials`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(response.statusText);
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
}